import { NavLink as MantineNavLink, rem } from '@mantine/core'
import { IconProps } from '@tabler/icons-react'
import { ReactElement, ReactNode, cloneElement } from 'react'
import { NavLink as RouterNavLink } from 'react-router'

const ICON_SIZE = 18
const FONT_SIZE = 14

type NavLinkProps = {
  to: string
  icon?: ReactElement<IconProps>
  label: string | ReactNode
  rightSection?: ReactNode
}

export const NavLink = ({ to, icon, label, rightSection }: NavLinkProps) => {
  const iconWithSize =
    icon &&
    cloneElement(icon, {
      size: ICON_SIZE
    })

  return (
    <MantineNavLink
      component={RouterNavLink}
      to={to}
      label={label}
      leftSection={iconWithSize}
      rightSection={rightSection}
      variant="light"
      color="brand-secondary"
      styles={{
        label: {
          fontSize: rem(FONT_SIZE),
          fontWeight: 600
        }
      }}
    />
  )
}

type ExternalNavLinkProps = {
  href: string
  icon?: ReactElement<IconProps>
  label: string | ReactNode
}

export const ExternalNavLink = ({
  href,
  icon,
  label
}: ExternalNavLinkProps) => {
  const iconWithSize =
    icon &&
    cloneElement(icon, {
      size: ICON_SIZE
    })

  return (
    <MantineNavLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      label={label}
      leftSection={iconWithSize}
      variant="light"
      color="brand-secondary"
      styles={{
        label: {
          fontSize: rem(FONT_SIZE),
          fontWeight: 600
        }
      }}
    />
  )
}
